var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03909 15.6182C7.03909 16.5901 6.25118 17.378 5.27931 17.378C4.30744 17.378 3.51953 16.59 3.51953 15.6182C3.51953 14.6463 4.30744 13.8584 5.27931 13.8584C6.25118 13.8584 7.03909 14.6463 7.03909 15.6182Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8389 15.6182C15.8389 16.5901 15.051 17.378 14.0791 17.378C13.1072 17.378 12.3193 16.59 12.3193 15.6182C12.3193 14.6463 13.1072 13.8584 14.0791 13.8584C15.051 13.8584 15.8389 14.6463 15.8389 15.6182Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6195 12.7587H14.9583V11.4388H5.93917V10.1189H14.9583C15.0962 10.1188 15.2307 10.0755 15.3427 9.99506C15.4548 9.91457 15.5388 9.80088 15.5829 9.67021L17.3427 4.39088L16.0932 3.97737L14.483 8.8079H5.76329L3.44035 0H0V1.31987H2.42847L4.61937 9.54697L4.6195 12.7587Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.0750a9b97d9f3f84d5a25b257663f401.svg";
export { ForwardRef as ReactComponent };